import type { CSSObject } from '@emotion/react';

export const baseBox: CSSObject = {
  boxSizing: 'border-box',
  minWidth: 0,
};
